import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./Header.css";
import pic from "./EnirisstLogo.png";
import Homepage from "../../HomePage/Homepage";
import GreekStatistics from "../../GreekStatistics/GreekStatistics";
import RoadSafetyIndicators from "../../RoadSafetyIndicators/RoadSafetyIndicators";
import RoadSafetyEvaluation from "../../RoadSafetyEvaluation/RoadSafetyEvaluaiton";
export default function Header() {
  const [index, setIndex] = useState(0);
  const [stickyClass, setStickyClass] = useState("relative");

  // useEffect(() => {
  //     window.addEventListener('scroll', stickNavbar);

  //     return () => {
  //       window.removeEventListener('scroll', stickNavbar);
  //     };
  //   }, []);

  //   const stickNavbar = () => {
  //     if (window !== undefined) {
  //       let windowHeight = window.scrollY;
  //       windowHeight > 61 ? setStickyClass('sticky') : setStickyClass('relative');
  //     }
  // };

  return (
    <Router>
      <nav
        className={`main-nav ${stickyClass}`}
        style={{ position: "relative", zIndex: 1 }}
      >
        <div className={"namain-nav__wrapper"}>
          <a className="logo" href="#">
            {" "}
            <img src={pic} alt={"Enirisst_logo"} />
          </a>
          <div className="rightSection">
            <span
              className={index === 0 ? "selected links" : "links"}
              style={{ width: 80 }}
              onClick={() => setIndex(0)}
            >
              <Link style={{ color: "inherit" }} to={"/"}>
                Αρχική
              </Link>
            </span>
            <span
              className={index === 1 ? "selected links" : "links"}
              style={{ width: 180 }}
              onClick={() => setIndex(1)}
            >
              <Link
                style={{ color: "inherit", width: 180 }}
                to={"/greek_statistics"}
              >
                Η Ελλάδα σε αριθμούς
              </Link>
            </span>
            <span
              className={index === 2 ? "selected links" : "links"}
              style={{ width: 200 }}
              onClick={() => setIndex(2)}
            >
              <Link style={{ color: "inherit" }} to={"/road_safety_indicators"}>
                Δείκτες Οδικής Ασφάλειας
              </Link>
            </span>
            <span
              className={index === 3 ? "selected links" : "links"}
              style={{ width: 250 }}
              onClick={() => setIndex(3)}
            >
              <Link style={{ color: "inherit" }} to={"/LookerReport"}>
                Αξιολόγηση Οδικής Ασφάλειας
              </Link>
            </span>
          </div>
        </div>
      </nav>
      <Routes>
        <Route exact path="/" element={<Homepage />} />
        <Route exact path="/greek_statistics" element={<GreekStatistics />} />
        <Route
          exact
          path="/road_safety_indicators"
          element={<RoadSafetyIndicators />}
        />
        <Route exact path="/LookerReport" element={<RoadSafetyEvaluation />} />
        <Route path="*" element={<Homepage />} />
      </Routes>
    </Router>
  );
}
